import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-[768px] min-h-screen pt-40 justify-center items-start flex" }
const _hoisted_3 = {
  key: 1,
  class: "sm:w-[768px] w-full min-h-screen pt-4"
}
const _hoisted_4 = { class: "flex justify-between w-full" }
const _hoisted_5 = { class: "flex items-center mb-4" }
const _hoisted_6 = { class: "w-10 h-10 mr-2 rounded-full" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-xl font-medium my-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold tracking-wide" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border-zinc-100 border-t border-solid w-full h-1 my-8" }, null, -1)
const _hoisted_11 = { class: "whitespace-pre-wrap text-sub text-sm my-6 w-full" }
const _hoisted_12 = { class: "text-end text-sub text-sm" }
const _hoisted_13 = { class: "w-full mt-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "bg-zinc-50 w-full h-1 my-8" }, null, -1)
const _hoisted_16 = { class: "text-sm font-medium" }
const _hoisted_17 = { class: "text-sub font-normal" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-sm text-sub" }, " 댓글을 보시려면 파충류 다 있다(파다) 앱을 다운로드해보세요! ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "border-zinc-100 border-solid w-full h-1 my-8" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, " <", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-20" }, null, -1)

import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { timeForToday } from '@/utils/timeForToday';
import { formattedPrice,  } from '@/utils/formattedUnit';
import { useRouter, useRoute } from 'vue-router';
import LoadingCircle from '../UI/LoadingCircle.vue';
import GoQRcode from '../UI/GoQRcode.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PostDetail',
  setup(__props) {

const route = useRoute();

const store = useStore();
const router = useRouter();
const postId = route.params.id

const postItem = computed(() => store.state.clickedPost || []);
const isLoading = computed(() => store.state.isLoading);
const backBtn = () => {
    router.go(-1)
}


onMounted(async () => {
    await store.dispatch('viewPost', postId);

})


return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LoadingCircle)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: postItem.value.img !== 'b' ? postItem.value.img : require('@/assets/img/logo/defaultProfile.svg'),
                alt: "",
                class: "w-full h-full rounded-full object-cover"
              }, null, 8, _hoisted_7)
            ]),
            _createTextVNode(" " + _toDisplayString(postItem.value.name), 1)
          ])
        ]),
        _createElementVNode("h1", _hoisted_8, _toDisplayString(postItem.value.title), 1),
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("p", _hoisted_11, _toDisplayString(postItem.value.content), 1),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(timeForToday)(postItem.value.create_at)), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: postItem.value.imgURL1,
            alt: "",
            class: "w-full rounded-lg"
          }, null, 8, _hoisted_14),
          _hoisted_15
        ]),
        _createElementVNode("p", _hoisted_16, [
          _createTextVNode("댓글 "),
          _createElementVNode("span", _hoisted_17, _toDisplayString(postItem.value.reply_cnt) + "개", 1)
        ]),
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("div", {
          class: "border border-solid border-[#d8d9dc] text-sub w-20 h-8 text-xs justify-center flex items-center rounded-md mt-4 cursor-pointer",
          onClick: backBtn
        }, [
          _hoisted_20,
          _createTextVNode(" 목록으로 ")
        ]),
        _createVNode(GoQRcode),
        _hoisted_21
      ]))
}
}

})